module.exports = Studio.libraries['react-list'];


/*****************
 ** WEBPACK FOOTER
 ** external "Studio.libraries['react-list']"
 ** module id = 3
 ** module chunks = 0
 **/